import React, { useState } from 'react';

import { capitalizeWord } from '../utils';
import iconInfo from '../../assets/info.svg';
import iconClose from '../../assets/close.svg';

import Modal from '../Modal/Modal.component';

import config from './AlphanumericCustomerNumber.config';
import './AlphanumericCustomerNumber.less';

const AlphanumericCustomerNumber = ({
  helper,
  input: { value, onChange: inputOnChange },
  label,
  placeholder,
  hint,
  withHelper,
  limit,
  intl: { formatMessage },
  meta: { touched, error, pristine },
  withSeparator,
}) => {
  const [modal, setModal] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const [reachEnd, setReachEnd] = useState(false);
  const [errorMax, setErrorMax] = useState(false);

  const onChange = event => {
    const inputValue = event.target.value;
    setReachEnd(inputValue.length === 18);
    inputOnChange(inputValue);
  };

  const onDismiss = () => {
    document.getElementById('inputCustomerNumber').blur();
    inputOnChange('');
    setIsFocus(false);
  };

  const changeModalVisibility = isVisible => () => {
    setModal(isVisible);
  };

  const onFocus = () => {
    setIsFocus(true);
  };

  const onBlur = () => {
    setIsFocus(false);
  };

  const onKeyDown = () => {
    if (reachEnd && !errorMax) {
      setErrorMax(true);

      setTimeout(() => {
        setErrorMax(false);
      }, 1000);
    } else if (!reachEnd && errorMax) {
      setErrorMax(false);
    }
  };

  const errorText = error || (errorMax ? 'validation.custNumberMax' : '');
  let errorMsg = '';
  let inputState = '';

  if (
    (!pristine && error && value.length > 3) ||
    (touched && error) ||
    (errorMax && reachEnd)
  ) {
    errorMsg = formatMessage(
      { id: errorText },
      {
        target: capitalizeWord(label),
        min: limit.min,
        max: limit.max,
      },
    );
    inputState = 'error';
  } else if (isFocus) {
    inputState = 'active';
  }

  const showHelper = typeof withHelper === 'boolean' && withHelper;
  const maxLength = limit.max;

  return (
    <>
      <div
        className="AlphanumericCustomerNumber"
        style={{
          borderBottom: withSeparator ? '0.6rem solid #f5f5f5' : 'none',
        }}
      >
        <div className="input-label">
          <span id="text_labelCustomerNumber">{label}</span>
        </div>
        <div className="input-row">
          <div className={`input-box ${inputState}`}>
            <input
              id="inputCustomerNumber"
              type="text"
              value={value}
              autoComplete="off"
              placeholder={placeholder}
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={onChange}
              onKeyDown={onKeyDown}
              maxLength={maxLength}
            />
            <button
              type="button"
              id="btn_closeCustomerNumber"
              className={`icon-status ${
                isFocus && value.length >= 1 ? 'show' : ''
              }`}
              onMouseDown={onDismiss}
            >
              <img src={iconClose} alt="close" />
            </button>
          </div>

          {showHelper && (
            <div
              id="btn_infoCustomerNumber"
              className="icon-info"
              onClick={changeModalVisibility(true)}
            >
              <img src={iconInfo} alt="Help" />
            </div>
          )}
        </div>
        <div className="input-hint">
          <span className={`show ${inputState}`} id="text_hintCustomerNumber">
            {errorMsg || hint}
          </span>
        </div>
      </div>
      {showHelper && (
        <Modal
          visible={modal}
          onClose={changeModalVisibility(false)}
          {...helper}
        />
      )}
    </>
  );
};

AlphanumericCustomerNumber.propTypes = config.propTypes;
AlphanumericCustomerNumber.defaultProps = config.defaultProps;
AlphanumericCustomerNumber.componentDetail = config.componentDetail;
AlphanumericCustomerNumber.builderConfig = config.builderConfig;

export default AlphanumericCustomerNumber;
